export default "__VITE_ASSET__87cb6676__"